import type { FC, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

import type { MediaLightboxStore } from './createMediaLightboxStore';

const MediaLightboxStoreContext = createContext<MediaLightboxStore | null>(null);

interface MediaLightboxStoreContextProviderProps {
  readonly store: MediaLightboxStore;
  readonly children: ReactNode;
}

export const MediaLightboxStoreContextProvider: FC<MediaLightboxStoreContextProviderProps> = ({ store, children }) => (
  <MediaLightboxStoreContext.Provider value={store}>{children}</MediaLightboxStoreContext.Provider>
);

export const useMediaLightboxStoreContext = (): MediaLightboxStore => {
  const store = useContext(MediaLightboxStoreContext);
  // istanbul ignore next
  if (store == null) {
    throw new Error('useMediaLightboxStoreContext must be used within a MediaLightboxStoreContextProvider');
  }

  return store;
};
